import Cookies from 'js-cookie'
import { $, on } from '../lib/domUtils'
import { addClass, removeClass } from '../lib/classie'

function toggleModal() {
  const body = document.querySelector('body')
  const modal = document.querySelector('.modal')
  modal.classList.toggle('opacity-0')
  modal.classList.toggle('pointer-events-none')
  body.classList.toggle('modal-active')
}

function openModal() {
  const body = document.querySelector('body')
  const modal = document.querySelector('.modal')
  if (!Cookies.get('promoClose')) {
    removeClass(modal, 'opacity-0')
    removeClass(modal, 'pointer-events-none')
    addClass(body, 'modal-active')
  }
}

function closeModal() {
  const body = document.querySelector('body')
  const modal = document.querySelector('.modal')
  addClass(modal, 'opacity-0')
  addClass(modal, 'pointer-events-none')
  removeClass(body, 'modal-active')
  Cookies.set('promoClose', true)
}

const overlay = document.querySelector('.modal-overlay')
overlay.addEventListener('click', closeModal)

const closemodal = document.querySelectorAll('.modal-close, .modal-close-button')
for (let i = 0; i < closemodal.length; i++) {
  closemodal[i].addEventListener('click', closeModal)
}

document.onkeydown = function(evt) {
  evt = evt || window.event
  let isEscape = false
  if ('key' in evt) {
    isEscape = evt.key === 'Escape' || evt.key === 'Esc'
  } else {
    isEscape = evt.keyCode === 27
  }
  if (isEscape && document.body.classList.contains('modal-active')) {
    toggleModal()
  }
}

window.setTimeout(function() {
  const modal = document.querySelector('.modal')
  if (modal) {
    openModal()
  }
}, 8000)
